module.exports = "<div #chartContainer></div>"